// TODO: Check "nookies" (Gleb Bigma)
import { signInApi, signUpApi } from '../../api/apiUrls/auth';
import authActionsTypes from '../actionTypes/authActionsTypes';
import helpers from '../../helpers/helpers';

const signUp = (email) => () => signUpApi(email)
  .then((response) => response)
  .catch(() => null);

const signInRequest = () => ({ type: authActionsTypes.AUTH_REQUEST });

export const signInSuccess = (token, tokenBitteam) => ({
  type: authActionsTypes.AUTH_SUCCESS,
  payload: {
    token,
    tokenBitteam,
  },
});

const signInFail = () => ({ type: authActionsTypes.AUTH_FAILURE });

const signIn = (data) => (dispatch) => {
  dispatch(signInRequest());
  return signInApi(data)
    .then((response) => {
      dispatch(signInSuccess(response.data.data.access_token, response.data.data.token_bit_team));
      return response;
    })
    .catch(() => {
      helpers.clearAuthCookie();
      dispatch(signInFail());
      return null;
    });
};

const signOut = () => (dispatch) => {
  helpers.clearAuthCookie();
  dispatch({ type: authActionsTypes.AUTH_SIGNOUT });
};

const saveUserData = (payload) => ({
  type: authActionsTypes.SAVE_USER_DATA,
  payload,
});

const authActions = {
  signUp,
  signIn,
  signOut,
  saveUserData,
};

export default authActions;
